import { useNode } from "@craftjs/core";
import * as React from "react";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import { Spinner } from "@/components/shared/spinner";

import Settings from "./iframe-settings";

export interface IFrameProps {
  src: string;
  title: string;
  height?: string;
  width?: string;
}

export default function Iframe(props: IFrameProps) {
  const {
    connectors: { connect },
  } = useNode();

  const [ready, setReady] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [dynamicHeight, setDynamicHeight] = React.useState(0);

  // Our schedules widget lets us know its height when it loads;
  // other cross domain urls won't.
  const shouldDynamicResize = React.useMemo(
    () => props.src.includes("/widgets/schedule"),
    [props.src]
  );

  React.useEffect(() => {
    function resize(event) {
      if (!shouldDynamicResize || isNaN(event.data)) {
        return;
      }

      const size = Math.round(event.data);
      if (!size) {
        return;
      }

      setDynamicHeight(size);
    }

    if (ready) {
      window.addEventListener("message", resize);

      return () => {
        window.removeEventListener("message", resize);
      };
    }
  }, [ready, shouldDynamicResize]);

  return (
    <div ref={connect}>
      <iframe
        title={props.title}
        src={props.src}
        onLoad={() => {
          setReady(true);
        }}
        onError={() => {
          setError(true);
        }}
        style={{
          height: !ready ? 0 : props.height || dynamicHeight,
          width: props.width,
          pointerEvents: "initial",
          display: "block",
          margin: "auto",
        }}
      />
      {!ready && (
        <div className="flex justify-center">
          <Spinner size="small" />
        </div>
      )}
      {error && <span>Something went wrong while loading this block.</span>}
    </div>
  );
}

Iframe.craft = {
  custom: {
    displayName: "IFrame",
  },
  related: {
    settings: Settings,
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
